module.exports = __webpack_public_path__ + "img/iot2.c2f4653c.png";